// The `ClubRepairs` component is a React functional component designed to display detailed information
// about repair services. It receives a `contentData` prop of type `RepairService` that includes the service name,
// description, and a list of service properties. Each property includes a name, description, and image, which are rendered in
// a grid layout. The component ensures a clean, responsive design with proper typography and spacing for a user-friendly experience.

import React from 'react';
import { MarkDownDescription } from 'components/commercetools-ui/atoms/markdown/markdown';
import { RepairService, ServiceProperty } from 'types/next';

interface ClubRepairsProps {
  contentData: RepairService;
}

const ClubRepairs = ({ contentData }: ClubRepairsProps) => {
  return (
    <>
      {contentData && (
        <div>
          <div className="p-15">
            <h1 className="mb-30 font-body text-[36px] font-bold leading-9">{contentData?.serviceName}</h1>
            <div className="text-start">
              <p className="font-body text-16 font-normal leading-[19.2px]">{contentData?.serviceDescription}</p>
            </div>
          </div>
          {contentData?.properties?.map((property: ServiceProperty, index: number) => {
            return (
              <div className="grid grid-cols-12  p-15" key={index}>
                <div className="col-span-12 sm:col-span-8">
                  <h2 className="mb-20 font-body text-28 font-normal leading-8">{property?.name}</h2>
                  <p className="font-body text-16 leading-[19.2px]">
                    <MarkDownDescription markdownText={property?.description} classname="clubrepair" />
                  </p>
                </div>
                <div className="col-span-12 sm:col-span-4">
                  <img src={property?.image} alt={property?.name} className="w-[100%]" />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ClubRepairs;
